import { useState } from 'react';

import { IAsset } from 'components/Pages/Admin/shared/ItinerariesItemLanding/Builder/types';
import { IDocumentBlockData } from 'detailsv2/__blocks';

export function useDocument(data: IDocumentBlockData) {
  const [openModal, setOpenModal] = useState(false);
  const [currentFile, setCurrentFile] = useState({});
  const filesLength = data?.files?.length || 0;
  const files = data?.files || [];

  const handlePreview = (enteredFile: IAsset) => {
    setOpenModal(true);
    setCurrentFile(enteredFile);
  };

  return { openModal, setOpenModal, filesLength, files, currentFile, handlePreview };
}
